export const ROLE_GUEST = 'Guest';
export const ROLE_RESTRICTED = 'Restricted user';
export const ROLE_USER = 'User';
export const ROLE_ADMIN = 'Admin';
export const ROLE_SUPERADMIN = 'Superadmin';
